import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { MarketFilters } from 'common'

export const useMarketAnalyticsQueryStore = defineStore('marketAnalyticsQueries', () => {
  const filters = ref<MarketFilters>()

  const filterKey = computed(() => {
    if (!filters.value) {
      return undefined
    }

    return JSON.stringify(filters.value)
  })

  const isQueryEnabled = ref<boolean>(false)

  /** Only enable when user opens POI menu or selects Points of Interest layer. Saves connections on initial load. */
  const pointsOfInterestRequested = ref<boolean>(false)

  function requestPointsOfInterest() {
    pointsOfInterestRequested.value = true
  }

  function resetPointsOfInterestRequested() {
    pointsOfInterestRequested.value = false
  }

  return {
    filters,
    filterKey,
    isQueryEnabled,
    pointsOfInterestRequested,
    requestPointsOfInterest,
    resetPointsOfInterestRequested
  }
})
